import type { UserModel } from '@/app/types/user-type.ts';
import type { AnalyticsEventMap, AnalyticsEventName, AuthMethod } from './events.ts';
import { getRegisteredUserType, identifyAnalyticsUser } from './person-properties.ts';
import { isPostHogConfigured, posthog } from './posthog.ts';

export function trackEvent<E extends AnalyticsEventName>(
  event: E,
  properties?: AnalyticsEventMap[E],
) {
  if (!isPostHogConfigured) {
    return;
  }

  posthog.capture(event, {
    ...properties,
    user_type: getRegisteredUserType() ?? 'unknown',
  });
}

export function trackUserLoggedIn(user: UserModel, authMethod: AuthMethod) {
  identifyAnalyticsUser(user, false);
  trackEvent('user_logged_in', { auth_method: authMethod });
}
